import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { SocialPostWithProductsFragmentDoc } from '../../fragments/__generated__/SocialPost.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SocialPostQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type SocialPostQuery = { socialPost: { id: string, created: any, externalLink: string, link: string, name: string, sortOrder: number, type: string, description: string, status: string, username: string, relatedProducts: Array<{ id: string, pk: number, thumbnailUrl: string | null, priceRange: { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } }, specifics: Array<{ id: string, pk: number, name: string, shortName: string, slug: string }> }>, images: Array<{ id: string, url: string, thumbnailUrl: string | null }> } | null };


export const SocialPostDocument = gql`
    query SocialPost($id: ID!) {
  socialPost(id: $id) {
    ...SocialPostWithProductsFragment
  }
}
    ${SocialPostWithProductsFragmentDoc}`;

/**
 * __useSocialPostQuery__
 *
 * To run a query within a React component, call `useSocialPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialPostQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSocialPostQuery(baseOptions: Apollo.QueryHookOptions<SocialPostQuery, SocialPostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SocialPostQuery, SocialPostQueryVariables>(SocialPostDocument, options);
      }
export function useSocialPostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SocialPostQuery, SocialPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SocialPostQuery, SocialPostQueryVariables>(SocialPostDocument, options);
        }
export type SocialPostQueryHookResult = ReturnType<typeof useSocialPostQuery>;
export type SocialPostLazyQueryHookResult = ReturnType<typeof useSocialPostLazyQuery>;
export type SocialPostQueryResult = Apollo.QueryResult<SocialPostQuery, SocialPostQueryVariables>;
export function refetchSocialPostQuery(variables: SocialPostQueryVariables) {
      return { query: SocialPostDocument, variables: variables }
    }